const DOCUMENT = 'UNIT_AGENCIES_';

const actions = {
  LOAD_AGENCIES_REQUEST: DOCUMENT + 'LOAD_AGENCIES_REQUEST',
  LOAD_AGENCIES_SUCCESS: DOCUMENT + 'LOAD_AGENCIES_SUCCESS',
  LOAD_AGENCIES_ERROR: DOCUMENT + 'LOAD_AGENCIES_ERROR',

  loadAgenciesRequest: data => ({
    type: actions.LOAD_AGENCIES_REQUEST,
    payload: data,
  }),

  loadAgenciesSuccess: data => ({
    type: actions.LOAD_AGENCIES_SUCCESS,
    payload: data,
  }),

  loadAgenciesError: data => ({
    type: actions.LOAD_AGENCIES_ERROR,
    payload: data,
  }),
};

export default actions;
